import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import ModalWaiting from "../Components/ModalWaiting";

function SlideDigitalReception() {
  const [appData, setAppData] = useState(null);
  const [config, setConfig] = useState(null);
  const [modalshow, setModalshow] = useState(true);
  const [isCleared, setIsCleared] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [albumUrl, setAlbumUrl] = useState("");
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    document.title = "受付";
    try {
      const queries = new URLSearchParams(window.location.search);
      const dParam = queries.get('d') || "";
      const params = queries.get('params') || "slidedigitalreception";

      if (dParam) {
        // 1. デコード処理
        let b64 = dParam.replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        const binStr = window.atob(b64);
        const bytes = new Uint8Array(binStr.length);
        for (let i = 0; i < binStr.length; i++) { bytes[i] = binStr.charCodeAt(i); }
        const jsonData = JSON.parse(new TextDecoder('utf-8').decode(bytes));

        // 2. クリア処理（GCP側の掃除）
        if (jsonData.clear === true) {
          localStorage.removeItem('user_order_config');
          setIsCleared(true);
          setModalshow(false);
          return;
        }

        const saved = localStorage.getItem('user_order_config');

        // 3. 【初回アクセス】GCPから直接Formへ（Iframeを介さないのでブロックされない）
        if (!saved && params.includes("reception")) {
          if (jsonData.paymentFormUrl) {
            window.location.href = jsonData.paymentFormUrl;
            return;
          }
        }

        // 4. 【2回目以降】データをセットしてGCP側で「確認画面」を表示
        setConfig(JSON.parse(saved));
        setAppData({ ...jsonData, params });
        setModalshow(false);
      } else {
        setModalshow(false);
      }
    } catch (e) {
      console.error("Init Error:", e);
      setModalshow(false);
    }
  }, []);

  const handleQuickSubmit = async () => {
    setModalshow(true);
    // あなたのGASのデプロイURL
    const gasBaseUrl = "https://script.google.com/macros/s/AKfycbxV78M9f2XuypgAEfJ3An-chZD1b_FmDONcUuuP9gCCMdY8hwCrGBatowwBVEXxIevS6A/exec";
    
    // ★重要: GASへ送るデータ(payload)に、新しい「uuid」を追加しました
    const payload = {
      action: "handleQuickPayment", // GAS側のdoPostで「書き込み処理」を判別するためのフラグ
      config: config,
      albumUrl: albumUrl,
      uuid: appData.uuid,           // ←★ココを追加！(前回のUUIDで上書きしてしまうバグを防止)
      userID: appData.userID,
      userName: appData.userName,
      payment: appData.payment || 1000,
      params: appData.params
    };

    try {
      // GASのdoPostへデータを投げる（ここでスプレッドシートへの書き込みが発生する）
      await fetch(gasBaseUrl, {
        method: 'POST',
        mode: 'no-cors', // GASへのPOSTでエラーを出さないため
        body: JSON.stringify(payload)
      });
      setIsFinished(true);
    } catch (err) {
      alert("送信に失敗しました。時間をおいて再度お試しください。");
    }
    setModalshow(false);
  };

  // --- 画面表示部分はGCPでサクサク描画 ---
  if (isCleared) return <div className="p-5 text-center"><h4>データクリア完了</h4></div>;
  if (isFinished) return <div className="p-5 text-center"><h4>お申し込み完了</h4><p>LINEをご確認ください。<br/><span className="small text-muted">×ボタンから画面を閉じてください</span></p></div>;

  return (
    <div className="p-3 bg-light min-vh-100">
      {config && (
        <Card className="mx-auto shadow-sm" style={{maxWidth: '500px'}}>
          <Card.Body>
            <h5 className="text-center fw-bold mb-4">お申し込み内容の確認</h5>
            <div className="bg-white p-3 border rounded mb-4 text-center">
              <div className="small text-muted">前回のご利用日</div>
              <div className="fw-bold fs-5 mb-2">{config.recordDate}</div>
              <div className="small text-muted">前回の支払い方法</div>
              <div className="fw-bold fs-5">{config.payMethod === 'Bank' ? '銀行振込' : config.payMethod}</div>
            </div>

            {!showInput ? (
              <div className="d-grid gap-3">
                <Button variant="primary" size="lg" onClick={() => setShowInput(true)}>前回と同じ内容で申し込む</Button>
                <Button variant="outline-secondary" onClick={() => window.location.href = appData.paymentFormUrl}>支払方法を変更する</Button>
              </div>
            ) : (
              <div>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">アルバム共有URL（任意）</Form.Label>
                  <Form.Control type="url" value={albumUrl} onChange={(e) => setAlbumUrl(e.target.value)} placeholder="https://photos.app.goo.gl/..." />
                </Form.Group>
                <Button variant="success" className="w-100 fw-bold" onClick={handleQuickSubmit}>お申し込みを確定する</Button>
              </div>
            )}
          </Card.Body>
        </Card>
      )}
      <ModalWaiting show={modalshow} />
    </div>
  );
}

export default SlideDigitalReception;
